// extracted by mini-css-extract-plugin
export default {"question-group-scroll-container":"BrainList_question-group-scroll-container__hueSj","question-group-container":"BrainList_question-group-container__hKzvo"};